export default "__VITE_ASSET__qA1YxeKS__"